import React from 'react';
import ReactECharts from 'echarts-for-react';
import LcNoData from '../../../../components/Generic/LcNoData';
import { SubscriptionData } from '../../../../services/saas/SaasModel';

interface Props {
    subscriptionData: SubscriptionData
}

const SubscriptionComercial: React.FC<Props> = (props) => {
  const screenWidth = window.innerWidth;
  let fontSize = screenWidth <= 1400 ? 10 : 12;
  var subscriptions = props.subscriptionData.subscriptions
  .sort((a, b) => {
      let percentageA = a.consumedUnits;
      let percentageB = b.consumedUnits;
      return percentageB - percentageA; 
  });
  const opt = {
      title: {
          right: "0",
          top: "0",
          textStyle: {
              fontSize: 11,
              fontWeight: 'normal',
              color: '#8b90a3',
              fontFamily: 'Inter',
          },
          backgroundColor:'transparent',
          borderRadius: [10],
          padding: [4, 8, 4, 8],
          itemGap: 8
      },
      grid: {
          top:  '40px',
          bottom:  '29%',
          left: '1%',
          right: '1%',
          containLabel:  true,
      },
      tooltip: {
          backgroundColor: '#f1f5fb',
          borderWidth: 0,
          textStyle: {
              fontSize: 10,
              fontFamily: 'Inter',
              color: '#2B304F',
          },
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          formatter: function (params) {
              let tooltip = "<b>" + params[0].axisValueLabel + "</b><br>";
              let consumedIndex = params.findIndex(p => p.seriesName === 'Atribuídas');
              let contractedIndex = params.findIndex(p => p.seriesName === 'Contratadas');

              if (consumedIndex !== -1 && contractedIndex !== -1) {
                  let consumedUnits = params[consumedIndex].value;
                  let contractedUnits = params[contractedIndex].value;
                  let percentage = ((consumedUnits / contractedUnits) * 100).toFixed(2);

                  tooltip += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[consumedIndex].color + '"></span> Atribuídas: ' + consumedUnits + "<br>";
                  tooltip += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[contractedIndex].color + '"></span> Contratadas: ' + contractedUnits + "<br>";
                  tooltip += "Porcentagem: " + percentage + "%";
              }
              return tooltip;
          }
      },
      xAxis: {
          type: 'category',
          data: subscriptions.map(item => item.displayName.trim()),
          axisLabel: {
              interval: 0,
              formatter: function (value) {
                  return value.length > 9 ? value.replace("Microsoft", "").slice(0, 9) + "..." : value;
              },
              fontSize: fontSize,
              fontFamily: 'Inter',
              color: '#8b90a3',
          },
          show: true,
      },
      yAxis: {
          axisLabel: {
              fontSize: fontSize,
              fontFamily: 'Inter',
              color: '#8b90a3',
          },
          show: true,
          splitLine: {
              show: true,
              lineStyle: {
                  type: 'dashed'
              },
          },
      },
      legend: {
          data: ['Atribuídas', 'Contratadas'],
          width: '100%',
          right: 'center',

          textStyle: {
              fontFamily: 'Inter',
              color: '#8b90a3',
              fontSize: fontSize,
          },
          bottom: '15%',
          inactiveColor: '#ededed',
          inactiveBorderColor: '#ededed',
          icon: 'circle',
      },
      series: [
          {
              name: 'Atribuídas',
              type: 'bar',
              //barGap: '20%',
              itemStyle: {
                  color: '#79c1cb',
                  opacity: 0.85
              },
              emphasis: {
                  itemStyle: {
                      opacity: 1
                  }
              },
              label: {
                  show: true,
                  position: 'top',
                  color: '#2B304F',
                  formatter: '{c}',
                  textStyle: {
                      color: '#9a9fb0', // Cor do texto
                      fontFamily: 'Inter', // Fonte do texto
                      fontSize: 9, // Tamanho da fonte
                  },
              },
              data: subscriptions.map(item => item.consumedUnits)
          },
          {
              name: 'Contratadas',
              type: 'bar',
              //barGap: '-100%',
              itemStyle: {
                  color: '#d0d3dc',
                  opacity: 0.85
              },
              emphasis: {
                  itemStyle: {
                      opacity: 1
                  }
              },
              label: {
                  show: true, // Mostra o label
                  position: 'top', // Posição do label acima da barra
                  color: '#2B304F', // Cor do texto
                  formatter: '{c}', // Formatação do conteúdo do label para mostrar o valor da barra
                  textStyle: {
                      color: '#9a9fb0', // Cor do texto
                      fontFamily: 'Inter', // Fonte do texto
                      fontSize: 9, // Tamanho da fonte
                  },
              },
              data: subscriptions.map(item => item.prepaidUnid)
          },
      ],
      dataZoom: [{
          type: 'slider',
          start: 0,
          end: (( 6) / subscriptions.length * 100) - 5,
          height: 17,
          show: true,
          bottom: '12px'
      }]
  };

  return (
    <>
        { props.subscriptionData ?
            <ReactECharts notMerge={true}
                lazyUpdate={true}
                style={{ width: '100%', height: '100%' }} opts={{ renderer: 'svg', locale: 'PT-br' }}
                option={opt} />
            :
            <LcNoData size="small" label="Não foram encontrados dados de licenciamento." />
        }
    </>
  )
}

export default SubscriptionComercial;